import React, { forwardRef, ForwardRefExoticComponent, HTMLAttributes, RefAttributes } from 'react';

import { Button, ButtonProps } from '../../button';

type DesktopNavbarButtonProps = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> &
  ButtonProps & {
    wrapperClassname?: string;
  };

const COMPONENT_ID = 'modulor-desktop-navbar-button';

export const DesktopNavbarButton: ForwardRefExoticComponent<DesktopNavbarButtonProps> = forwardRef<
  HTMLDivElement,
  DesktopNavbarButtonProps
>(({ wrapperClassname, ...buttonProps }, ref) => {
  return (
    <div ref={ref} data-id={COMPONENT_ID} className={wrapperClassname}>
      <Button {...(buttonProps as ButtonProps)} />
    </div>
  );
});

DesktopNavbarButton.displayName = 'DesktopNavbarButton';
